import React from "react";

// Set the company name here and it will be inserted in each of the messages below
const companyName = 'ABC Insurance';

// Set this to true to support one message per product version.  When false, it will 
// use the lineCd value in the first product line (when available).
const useProductVersion = false;


// This file is for adding a formatted text description of the consent form. It detects the product line 
// and version for the quote and displays an appropriate message.  This is controlled by the lineCd value 
// unless the variable useProductVersion is set to true.
export const ConsumerConsentData = () => {
  const data = history.state.data;
  const lineCd = ((data.model.lines && (data.model.lines.length > 0)) ? data.model.lines[0].lineCd : '');
  const msgKey = (((!useProductVersion) && lineCd) ? lineCd : data.model.basicPolicy.productVersionIdRef);

  switch (msgKey) {
    case 'iic-CA-Homeowners-v01-00-00':
    case 'Homeowners':
      return (
        <ol>
          <li>I understand that I am requesting the purchase of home owner's insurance from {companyName}.</li>
          <li>I warrant that all information I have provided is true and accurate to the best of my knowledge.</li>
          <li>I am authorizing {companyName} to confirm the property information with the appropriate agencies and understand that my coverage(s) and/or premiums may change if differences are found.</li>
          <li>I understand that my payment by credit card or electronic transfer of funds will be collected, and that if the payment is declined by the Financial Institution, my coverage will be null and void.</li>
        </ol>
      );
      break;
    case 'iic-CA-PersonalAuto-v01-00-00':
    case 'PersonalAuto':
      return (
        <ol>
          <li>I understand that I am requesting the purchase of personal automobile insurance from {companyName}.</li>
          <li>I warrant that all information I have provided is true and accurate to the best of my knowledge.</li>
          <li>I am authorizing {companyName} to confirm the driving records of all drivers with the appropriate agencies and understand that my coverage(s) and/or premiums may change if differences are found.</li>
          <li>I understand that my payment by credit card or electronic transfer of funds will be collected, and that if the payment is declined by the Financial Institution, my coverage will be null and void.</li>
        </ol>
      );
      break;
    default:
      return (
        <ol>
          <li>I understand that I am requesting the purchase of insurance from {companyName}.</li>
          <li>I warrant that all information I have provided is true and accurate to the best of my knowledge.</li>
          <li>I am authorizing {companyName} to confirm my information with the appropriate agencies and understand that my coverage(s) and/or premiums may change if differences are found.</li>
          <li>I understand that my payment by credit card or electronic transfer of funds will be collected, and that if the payment is declined by the Financial Institution, my coverage will be null and void.</li>
        </ol>
      );
      break;
  }
};
